import {
    DialogDescription
} from 'shared/components/ui/dialog';
import QueryInterface from './QueryInterface';
import QueryResult from './QueryResult';

import {
    useContext
} from 'react';
import {
    SidebarContext
} from '../knowledgeBuilderContext/KBSidebarContext';
import DocViewer from './DocViewer';
import {
    Button
} from 'shared/components/ui/button';
import {
    Copy
} from 'lucide-react';

export default function QueryModal() {
    const {
        queryResults, selectedQuery, QueryResultDetails, loadMoreQuery, queryLoading, searchType
    } = useContext(SidebarContext);

    return (
        <div className="flex flex-col h-full">
            <DialogDescription className="mt-3 mb-6">Search your database by providing a query.</DialogDescription>
            <QueryInterface />
            <div className="grid gap-6 relative flex-grow min-h-0 grid-cols-3 mt-3">

                {/* First Column */}
                <div className="flex flex-col h-full rounded-xl border bg-background shadow-sm overflow-hidden">
                    <div className="flex items-center justify-between p-4 border-b bg-muted/30">
                        <h5 className="font-semibold text-base text-foreground">Results</h5>
                        <div className="px-2 py-0.5 bg-muted rounded-md text-xs font-medium text-muted-foreground">
                            {queryResults.length} Found
                        </div>
                    </div>
                    <div className="flex-grow overflow-y-auto p-2 bg-background [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
                        {queryResults.length > 0 ? queryResults.map((result) => (
                            <QueryResult searchType={searchType} selected={selectedQuery?.chunk_id === result.chunk_id} result={result} chunkId={result.chunk_id} key={result.chunk_id} fileName={result.document_name} />
                        )) : (
                            <div className="flex items-center justify-center h-full text-muted-foreground text-sm">No results found for the search.</div>
                        )}
                        {!queryLoading && QueryResultDetails.current?.remaining_items
                            ? <div className="flex items-center justify-center mt-2 pb-2">
                                <Button onClick={loadMoreQuery} variant="outline" size="sm" className="rounded-full h-7 text-xs">Load More</Button>
                            </div>
                            : null}
                    </div>
                </div>

                {/* Second Column */}
                <div className="flex flex-col h-full rounded-xl border bg-background shadow-sm overflow-hidden">
                    <div className="flex items-center justify-between p-4 border-b bg-muted/30 h-[57px]">
                        <h5 className="font-semibold text-base text-foreground">Text Content</h5>
                        {selectedQuery && (
                            <Button
                                variant="ghost"
                                size="icon"
                                className="h-7 w-7"
                                onClick={() => {
                                    navigator.clipboard.writeText(selectedQuery.text);
                                }}
                                title="Copy text"
                            >
                                <Copy size={14} className="text-muted-foreground" />
                            </Button>
                        )}
                    </div>
                    <div className="flex-grow h-0 p-4 bg-background">
                        {
                            selectedQuery ? (
                                <div className="h-full overflow-y-auto pr-2 whitespace-pre-wrap text-sm text-muted-foreground leading-relaxed [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
                                    {selectedQuery?.text}
                                </div>
                            ) : <div className="h-full w-full flex items-center justify-center text-muted-foreground italic text-sm">Select a result to view content</div>

                        }
                    </div>
                </div>

                {/* Third Column */}
                <div className="flex flex-col h-full rounded-xl border bg-background shadow-sm overflow-hidden">
                    <div className="flex items-center justify-between p-4 border-b bg-muted/30">
                        <h5 className="font-semibold text-base text-foreground">Document Preview</h5>
                    </div>
                    <div className="flex-grow h-0 p-0 bg-background relative">
                        {selectedQuery ? (
                            <DocViewer key={selectedQuery.chunk_id} document={selectedQuery} name={selectedQuery?.document_name || ''} page={1} />
                        ) : (
                            <div className="flex flex-col items-center justify-center h-full text-muted-foreground">
                                <p>No document selected</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

}